"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PivotTableDescriptor = void 0;
var tslib_1 = require("tslib");
// (C) 2021-2022 GoodData Corporation
var sdk_model_1 = require("@gooddata/sdk-model");
var sdk_ui_1 = require("@gooddata/sdk-ui");
var PluggablePivotTable_1 = require("./PluggablePivotTable");
var BaseChartDescriptor_1 = require("../baseChart/BaseChartDescriptor");
var drillDownUtil_1 = require("../drillDownUtil");
var embeddingCodeGenerator_1 = require("../../../utils/embeddingCodeGenerator");
var pivotTableConfigFromInsight_1 = require("./pivotTableConfigFromInsight");
var pivotTableAdditionalFactories_1 = require("./pivotTableAdditionalFactories");
var PivotTableDescriptor = /** @class */ (function (_super) {
    tslib_1.__extends(PivotTableDescriptor, _super);
    function PivotTableDescriptor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getEmbeddingCode = embeddingCodeGenerator_1.getReactEmbeddingCodeGenerator({
            component: {
                importType: "named",
                name: "PivotTable",
                package: "@gooddata/sdk-ui-pivot",
            },
            insightToProps: embeddingCodeGenerator_1.getInsightToPropsConverter({
                measures: embeddingCodeGenerator_1.multipleAttributesOrMeasuresBucketConversion("measures", sdk_ui_1.BucketNames.MEASURES),
                rows: embeddingCodeGenerator_1.multipleAttributesBucketConversion("rows", sdk_ui_1.BucketNames.ATTRIBUTE),
                columns: embeddingCodeGenerator_1.multipleAttributesBucketConversion("columns", sdk_ui_1.BucketNames.COLUMNS),
                filters: embeddingCodeGenerator_1.filtersInsightConversion("filters"),
                sortBy: embeddingCodeGenerator_1.sortsInsightConversion("sortBy"),
                totals: embeddingCodeGenerator_1.totalsInsightConversion("totals"),
                config: embeddingCodeGenerator_1.insightConversion("config", {
                    typeImport: {
                        importType: "named",
                        name: "IPivotTableConfig",
                        package: "@gooddata/sdk-ui-pivot",
                    },
                    cardinality: "scalar",
                }, pivotTableConfigFromInsight_1.pivotTableConfigFromInsight),
                locale: embeddingCodeGenerator_1.localeInsightConversion("locale"),
                execConfig: embeddingCodeGenerator_1.executionConfigInsightConversion("execConfig"),
            }),
            additionalFactories: pivotTableAdditionalFactories_1.pivotTableAdditionalFactories,
        });
        return _this;
    }
    PivotTableDescriptor.prototype.getFactory = function () {
        return function (params) { return new PluggablePivotTable_1.PluggablePivotTable(params); };
    };
    PivotTableDescriptor.prototype.getSizeInfo = function (_insight, layoutDescriptor, settings) {
        return {
            width: {
                default: layoutDescriptor.gridColumnsCount,
                min: 3,
                max: layoutDescriptor.gridColumnsCount,
            },
            height: {
                default: this.getDefaultHeight(settings.enableKDWidgetCustomHeight),
                min: this.getMinHeight(settings.enableKDWidgetCustomHeight),
                max: this.getMaxHeight(settings.enableKDWidgetCustomHeight),
            },
        };
    };
    PivotTableDescriptor.prototype.applyDrillDown = function (insight, drillDownContext, backendSupportsElementUris) {
        var drillDownInsight = drillDownUtil_1.modifyBucketsAttributesForDrillDown(insight, drillDownContext.drillDefinition);
        var drillDownInsightWithFilters = drillDownUtil_1.addIntersectionFiltersToInsight(drillDownInsight, drillDownContext.event.drillContext.intersection, backendSupportsElementUris);
        return drillDownUtil_1.sanitizeTableProperties(sdk_model_1.insightSanitize(drillDownInsightWithFilters));
    };
    PivotTableDescriptor.prototype.getMeta = function () {
        return {
            documentationUrl: "https://sdk.gooddata.com/gooddata-ui/docs/pivot_table_component.html",
            supportsExport: true,
            supportsZooming: false,
        };
    };
    return PivotTableDescriptor;
}(BaseChartDescriptor_1.BaseChartDescriptor));
exports.PivotTableDescriptor = PivotTableDescriptor;
//# sourceMappingURL=PivotTableDescriptor.js.map